import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { UserInfo, UserInfoHeader } from '../models/user-info.model';
import { AuthConfig } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class UserInfoService {
  private readonly AMBaseURL: string = AuthConfig.AMBaseURL;
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);

  userInfo: WritableSignal<UserInfoHeader> = signal({
    username: 'Loading...',
    department: '',
    profileImg: '',
  });

  getUserInfo(): Observable<UserInfo> {
    const accessToken = this.authService.getAccessToken();
    const headers = new HttpHeaders({ Authorization: `Bearer ${accessToken}` });
    const url = `${this.AMBaseURL}/oauth2/${AuthConfig.realmPath}/userinfo`;

    return this.http
      .get<UserInfo>(url, { headers })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: unknown): Observable<never> {
    console.error('An error occurred:', error);
    return throwError(
      () => new Error('Something went wrong; please try again later.')
    );
  }
}
